<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import { Api } from "@/core/api.js";

import router from "./router";
import Vue from "vue";
import VueAnalytics from "vue-analytics";

import VueGtag from "vue-gtag";
const api = new Api();
const default_layout = "default";

const isProd = process.env.NODE_ENV == "production";
Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_GoogleAnaylticsKey },
    pageTrackerScreenviewEnabled: true,
    pageTrackerTemplate(to) {
      return {
        page_title: to.name,
        page_path: to.path
      };
    }
  },
  router
);

// Vue.use(VueAnalytics, {
//   id: 'UA-149877352-1',
//   router,
//   debug: {
//     enabled: !isProd,
//     sendHitTask: isProd
//   }
// })

export default {
  computed: {
    layout() {
      var layout =
        typeof this.$route.meta.layout !== "undefined"
          ? this.$route.meta.layout
          : default_layout;
      return layout + "-layout";
    }
  },
  mounted() {}
};
</script>

<style lang="scss"></style>
